import { RSAA } from "redux-api-middleware";
import {
  markSportsmenAction,
  markClassificationTeamsAction,
} from "./markedSportsmenReducer";

export const markTeamSportsmen = (teamId, classificationId) => (
  dispatch,
  getState
) =>
  dispatch({
    [RSAA]: {
      endpoint: `/api/v1/game/${
        getState().games.current.id
      }/team/${teamId}/sportsmen/classification/${classificationId}`,
      method: "GET",
      credentials: "same-origin",
      types: [
        "REQUEST",
        {
          type: "SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              dispatch(
                markSportsmenAction(json.data, json.relationships.teams)
              );
            }),
        },
        "FAILURE",
      ],
    },
  });

export const markClassificationSportsmen = (sportsmanId) => (
  dispatch,
  getState
) => {
  const zweelerTeamIds = getState().ranking.entries.map(
    (entry) => entry.zweelerTeamId
  );
  return dispatch({
    [RSAA]: {
      endpoint: `/api/v1/game/${
        getState().games.current.id
      }/sportsman/${sportsmanId}/teams`,
      method: "POST",
      credentials: "same-origin",
      types: [
        "REQUEST",
        {
          type: "SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              dispatch(markClassificationTeamsAction(json));
            }),
        },
        "FAILURE",
      ],
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(zweelerTeamIds),
    },
  });
};
